export const onDialogExited = dialogType => ({
  widget: 'projects',
  type: 'onDialogExited',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/projects/actions/onDialogExited.js